const getUrlParams = (url) => {
  const hashes = url.slice(url.indexOf('?') + 1).split('&');
  const params = {};
  hashes.map(hash => {
    const [key, val] = hash.split('=');
    params[key] = decodeURIComponent(val)
  });
  return params;
};

const params = getUrlParams(window.location.search);

export const getUrlParam = (name) => {
  return params[name];
}
